// WhyRoshTech.jsx

import React from 'react';
import './WhyRoshTech.css';
import { FaLightbulb, FaUsers, FaShieldAlt, FaRocket } from 'react-icons/fa';

const features = [
  {
    icon: <FaLightbulb />,
    title: 'Innovative Solutions',
    description: 'We develop cutting-edge software tailored to address Africa’s unique challenges, ensuring relevance and impact.',
  },
  {
    icon: <FaUsers />,
    title: 'User-Centric Design',
    description: 'Our products are designed with the end-user in mind, ensuring intuitive interfaces and seamless experiences.',
  },
  {
    icon: <FaShieldAlt />,
    title: 'Reliable & Secure',
    description: 'We prioritize security and reliability, ensuring our solutions are trustworthy and dependable.',
  },
  {
    icon: <FaRocket />,
    title: 'Scalable Growth',
    description: 'Our platforms are built to scale, supporting your growth from startup to enterprise.',
  },
];

const WhyRoshTech = () => {
  return (

    <>
    <section className="why-roshtech">
      <h2>Why Choose RoshTech?</h2>
      <p className="subtitle">
        Empowering Africa's digital transformation through innovative and reliable software solutions.
      </p>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div className="icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>

<section className="cta-section">
  <h3>Want to experiment with our software to see how it works?</h3>
  <p>Let's get in touch and arrange for a demo.</p>
  <a href="/request-demo">Request Demo</a>
</section>
    </>
    
  );
};

export default WhyRoshTech;
